import React, { useEffect, useState } from "react";

import API from "../../../services/api";

import PersonalForm from "../../../components/delivery/EditProfile/PersonalForm/PersonalForm";
import VehicleForm from "../../../components/delivery/EditProfile/VehicleForm/VehicleForm";
import BankForm from "../../../components/delivery/EditProfile/BankForm/BankForm";
import ProfilePhoto from "../../../components/delivery/EditProfile/ProfilePhoto/ProfilePhoto";
import SaveButton from "../../../components/delivery/EditProfile/SaveButton/SaveButton";

import "./EditProfile.css";

function EditProfile() {

    const [profile, setProfile] = useState(null);

    const [loading, setLoading] = useState(true);

    const fetchProfile = async () => {

        try {

            const response = await API.get(
                "/delivery/profile"
            );

            if (response.data.success) {

                setProfile(
                    response.data.deliveryPartner
                );

            }

        }

        catch (error) {

            console.log(error);

        }

        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        fetchProfile();

    }, []);

    if (loading) {

        return (

            <div className="edit-profile-loading">

                Loading Profile...

            </div>

        );

    }

    return (

        <div className="edit-profile-page">

            <ProfilePhoto
                profile={profile}
                setProfile={setProfile}
            />

            <PersonalForm
                profile={profile}
                setProfile={setProfile}
            />

            <VehicleForm
                profile={profile}
                setProfile={setProfile}
            />

            <BankForm
                profile={profile}
                setProfile={setProfile}
            />

            <SaveButton
                profile={profile}
            />

        </div>

    );

}

export default EditProfile;